import React from 'react'
import { useTypedSelector } from '../../Hooks/useTypedSelector'
import LoginIconLink from '../Login/ui/LoginIconLink'
import RegisterCustomerLink from '../Register/RegisterCustomerLink'
import LoginModalTrigger from '../Login/LoginModalTrigger'
import MiniCartButton from '../MiniCart/MiniCartButton'
import WishListButton from '../WishList/WishListButton'

const HeaderNavigationIconLinks = (props) => {
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );
  const wishListPageUrl = props.href;

  return (
    <div className="min-h-[56px] lg:min-h-[64px] hidden lg:flex flex-1 justify-end items-center box-border no-underline lg:gap-3 lg:flex-none lg:-mr-2 [&_img]:w-5 [&_img]:h-auto [&_.icon]:text-[2rem] [&_.icon]:w-6 [&_.icon]:h-6 [&_.icon]:pointer-events-none [&_.icon]:lg:w-8 [&_.icon]:lg:h-8">
      {!userInfo && (
        <RegisterCustomerLink></RegisterCustomerLink>
      )}
      {userInfo ? (
        <LoginIconLink />
      ) : (
        <LoginModalTrigger />
      )}
      {wishListPageUrl && (
        <a href={wishListPageUrl} title={wishListPageUrl} aria-label={wishListPageUrl}>
          <WishListButton></WishListButton>
        </a>
      )}
      <MiniCartButton></MiniCartButton>
    </div>
  )
}

export default HeaderNavigationIconLinks